"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { FeaturesHero } from "~/components/inbound-gpt/FeaturesHero";
import { FeaturesHitlTeamSection } from "~/components/inbound-gpt/FeaturesHitlTeamSection";
import {
  AgentIntegrationsSection,
  Capabilities,
} from "~/components/inbound-gpt/Capabilities";
import { FeaturesAllAgentsSection } from "~/components/inbound-gpt/FeaturesAllAgentsSection";
import { MarketingExploreCta } from "~/components/inbound-gpt/MarketingExploreCta";
import {
  FEATURES_SECTION_HASH_ALIASES,
  MARKETING_FEATURES,
  scrollToInboundSection,
} from "~/lib/inbound-gpt/paths";
import { getMarketingChrome } from "~/lib/siteglue/marketing-chrome";

export function FeaturesPageContent() {
  const pathname = usePathname();
  const isSiteGlue = getMarketingChrome().brandId === "siteglue";

  useEffect(() => {
    if (pathname !== MARKETING_FEATURES) return;
    const hash = window.location.hash.replace(/^#/, "");
    if (!hash) return;
    const sectionId =
      hash === "demo"
        ? "agents"
        : FEATURES_SECTION_HASH_ALIASES[hash] ?? hash;
    const timer = window.setTimeout(() => scrollToInboundSection(sectionId), 150);
    return () => window.clearTimeout(timer);
  }, [pathname]);

  return (
    <>
      <FeaturesHero />
      {isSiteGlue ? <FeaturesHitlTeamSection /> : null}
      <Capabilities />
      <AgentIntegrationsSection />
      <FeaturesAllAgentsSection />
      <MarketingExploreCta className="mx-auto my-16 max-w-4xl px-4 sm:px-6 lg:px-8" />
    </>
  );
}
